export default function deleteWiredDevice(state, action) {
  const { id } = action
  const wiredDevices = { ...state.entities.wiredDevices.byId }
  delete wiredDevices[id]

  return Object.assign({}, state, {
    entities: {
      ...state.entities,
      wiredDevices: {
        byId: wiredDevices,
        allIds: state.entities.wiredDevices.allIds.filter(currentId => currentId !== id)
      }
    },
    currentEntity: {
      type: "map"
    }
  })
}



// WEBPACK FOOTER //
// ./src/reducers/deleteWiredDevice.js